import { useState, useEffect } from 'react';
import API from '../utils/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}

export function usePushNotifications() {
  const [supported, setSupported]   = useState(false);
  const [permission, setPermission] = useState('default');
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading]       = useState(false);

  useEffect(() => {
    setSupported('serviceWorker' in navigator && 'PushManager' in window);
    setPermission(Notification.permission);
  }, []);

  const subscribe = async () => {
    if (!supported) return;
    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.register('/sw.js');
      const { data } = await API.get('/push/vapid-public-key');
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey),
      });
      await API.post('/push/subscribe', sub.toJSON());
      setPermission('granted');
      setSubscribed(true);
    } catch (err) {
      if (err.name === 'NotAllowedError') setPermission('denied');
      console.error('Push subscribe error:', err.message);
    }
    setLoading(false);
  };

  const unsubscribe = async () => {
    setLoading(true);
    try {
      const reg  = await navigator.serviceWorker.getRegistration('/sw.js');
      const sub  = await reg?.pushManager.getSubscription();
      if (sub) {
        await API.delete('/push/unsubscribe', { data: { endpoint: sub.endpoint } });
        await sub.unsubscribe();
      }
      setSubscribed(false);
    } catch (err) { console.error('Push unsubscribe error:', err.message); }
    setLoading(false);
  };

  // Check existing subscription on mount
  useEffect(() => {
    if (!supported) return;
    navigator.serviceWorker.register('/sw.js').then(reg =>
      reg.pushManager.getSubscription().then(sub => setSubscribed(!!sub))
    ).catch(() => {});
  }, [supported]);

  return { supported, permission, subscribed, loading, subscribe, unsubscribe };
}
